import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

const ArthaCancelButton = styled(Button)(({ theme }) => ({
  background: "white",
  color: "black",
  boxShadow: "none",
  minWidth: "80px",
  width: "auto",
  maxWidth: "100%",
  height: "30px",
  padding: "6px 16px",
  textTransform: "capitalize",
  borderRadius: "40px",
  fontWeight: "800",
  margin: "0px 3px",
  border: "1px solid rgb(228 228 228) !important",
  whiteSpace: "nowrap",

  "&:hover": {
    color: "black",
    boxShadow: "none !important",
    background: "white",
  },
  // Mobile responsive
  "@media (max-width: 576px)": {
    minWidth: "70px",
    height: "28px",
    fontSize: "11px",
    padding: "4px 12px",
    margin: "0px 2px",
  },
  // Tablet responsive
  "@media (min-width: 577px) and (max-width: 991px)": {
    minWidth: "80px",
    height: "30px",
    fontSize: "11px",
    padding: "5px 14px",
  },
}));

export default ArthaCancelButton;
